<template>
  <div class="flex gap-4 items-center justify-between">
    <CTableInput
      :class="{ 'w-full max-w-[400px]': getInputState(activeInputId === AGENDA_NAME_KEY) === 'edit' }"
      :max-length="64"
      :model-value="
        getInputState(activeInputId === AGENDA_NAME_KEY) === 'view'
          ? agenda.name || t('canvasUI.agendaSelector.defaultNewAgenda')
          : agenda.name
      "
      readonly
      state="view"
      value-class="color-primary font-size-5 line-height-8 tracking-[0.25px]"
      @cancel="clearActiveInput()"
      @edit="setActiveInput(AGENDA_NAME_KEY)"
      @update:modelValue="updateAgendaName"
    />

    <CButton iconPlacement="left" type="primary" @click="addGroup()">
      {{ t('canvasUI.agendaSelector.createAgendaItem') }}

      <template #icon>
        <CIcon icon="plus" size="16" />
      </template>
    </CButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CTableInput from '@lib/components/CTableInput/CTableInput.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { useTableInput } from '@agenda-selector/composables/table-input.use'
import { useAppStore } from '@agenda-selector/stores/app.store'

const AGENDA_NAME_KEY = 'agendaNameKey'

const { t } = useI18n()
const { activeInputId, getInputState, setActiveInput, clearActiveInput } = useTableInput()
const { agenda, updateAgendaName: updateAgendaNameOperation, addGroup } = useAppStore()

const updateAgendaName = (name: string) => {
  updateAgendaNameOperation(name)
  clearActiveInput()
}
</script>
